/* eslint-disable @angular-eslint/no-inputs-metadata-property */
import { CdkTreeNodeToggle } from '@angular/cdk/tree';
import { Directive } from '@angular/core';

/**
 * Wrapper for the CdkTree's toggle.
 */
@Directive({
  selector: '[nTreeNodeToggle]',
  providers: [{ provide: CdkTreeNodeToggle, useExisting: NTreeNodeToggleDirective }],
  inputs: ['recursive: nTreeNodeToggleRecursive'],
})
export class NTreeNodeToggleDirective<T, K = T> extends CdkTreeNodeToggle<T, K> {}
